// extracted by css-extract-rspack-plugin
export default {"sidebarSectionsLoadingContainer":"SidebarSectionsLoading-module__sidebarSectionsLoadingContainer__hDjzQ"};